// sharing
export const TITLE = 'The 2022 Lemonade Giveback';
export const SHARING_EVENT = 'giveback2022.share.clicked';
export const SHARING_URL = 'https://bit.ly/3NXPmWk';
export const SHARING_CONTENT =
  'I just helped fund medical kits for Ukrainian refugees, animal rescue projects, LGBTQ+ orgs, and reforestation simply by having a @Lemonade_Inc insurance policy. How cool is that! #LemonadeGiveback';
